<template>
  <div class="w-full p-4">
    <div class="w-full bg-gray-100 rounded-lg p-1 flex gap-1 shadow-sm">
      <button
          class="flex-1 py-2.5 rounded-lg text-center text-sm md:text-base font-medium transition-all outline-none "
          :class="active === 'tab1' ? 'bg-primary text-white shadow' : 'text-gray-600 hover:text-gray-800'"
          @click="active = 'tab1'"
          role="tab"
          :aria-selected="active === 'tab1'"
      >
        تایید تحویل خارجی
      </button>
      <button
          class="flex-1 py-2.5 rounded-lg text-center text-sm md:text-base font-medium transition-all outline-none"
          :class="active === 'tab2' ? 'bg-primary text-white shadow' : 'text-gray-600 hover:text-gray-800'"
          @click="active = 'tab2'"
          role="tab"
          :aria-selected="active === 'tab2'"
      >
        تایید تحویل ایرانی
      </button>
    </div>

    <div class="mt-3 bg-white rounded-2xl p-4 border">
      <keep-alive>
        <component :is="currentComp" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliverVerify',
  data() {
    return {
      active: 'tab1',
    };
  },
  computed: {
    currentComp() {
      return this.active === 'tab1' ? 'TabChina' : 'TabDomestic';
    },
  },
  components: {
    TabChina: () => import('@/modules/delivery/NeedVerifyDeliver'),
    TabDomestic: () => import('@/modules/delivery/DomesticNeedVerifyDeliver'),
  },
};
</script>
<style scoped>
</style>
